import React from "react";

import RiskFinancingOverview from
  "../../../components/risk_financing/overview/RiskFinancingOverview";

import useRiskFinancingContext from
  "../context/useRiskFinancingContext";
import { useAccess } from "../../../access/AccessContext";
import { PERMISSIONS } from "../../../access/capabilities";


export default function RiskFinancingPortfolioTab({
  settings,
}) {
  const access = useAccess();
  const canExecute = access.hasPermission(PERMISSIONS.financing.execute);
  const {
    portfolio,
    decisionAnalysis,
    navigation,
  } = useRiskFinancingContext();

  const {
    strategy,
    summary,
    data: portfolioData,
    state,
    actions,
  } = portfolio;

  return (
    <RiskFinancingOverview
      summary={summary}
      portfolioData={portfolioData}
      decisionData={decisionAnalysis.analysis}
      strategy={strategy}
      settings={settings}
      loading={state.loading}
      error={state.error}
      onStrategyChange={canExecute ? actions.changeStrategy : undefined}
      onRecalculate={canExecute ? actions.recalculate : undefined}
      onReviewCoverage={() =>
        navigation.setActiveTab("coverage")
      }
      onCompareAlternatives={canExecute ? () =>
        navigation.setActiveTab("decision_analysis")
      : undefined}
    />
  );
}
